// extracted by mini-css-extract-plugin
export var brand = "_bw-9";
export var compact = "_bw-6";
export var extraSmall = "_bw-7";
export var icon = "_bw-0";
export var large = "_bw-4";
export var light = "_bw-1";
export var medium = "_bw-5";
export var outline = "_bw-b";
export var primaryDark = "_bw-a";
export var primaryLight = "_bw-8";
export var primaryModern = "_bw-c";
export var success = "_bw-2";
export var successSolid = "_bw-3";